import {Component, Input, OnInit} from '@angular/core';
import {Project, Transaction, User} from '../../../../core/models';
import {UUIDHashPipe} from '../../../../shared/uuid-hash.pipe';

@Component({
  selector: 'app-project-activity-build-summary',
  templateUrl: './activity-build-summary.html'
})
export class ActivityBuildSummaryComponent implements OnInit {
  @Input() project: Project;
  @Input() activity: Transaction;
  operationPrefix: string;
  operationSuffix: string;
  shortTransactionId: string;
  reporter: User;
  link: any;
  branchLink: any;

  constructor() {
  }

  ngOnInit() {
    this.operationPrefix = 'Transaction';
    this.operationSuffix = this.getText(this.activity.status);
    this.shortTransactionId = UUIDHashPipe.transform(this.activity.id);

    this.link = [
      '/project',
      this.project.id,
      'branch',
      this.activity.branch.id,
      'transaction',
      this.activity.id
    ];

    this.branchLink = [
      '/project',
      this.project.id,
      'branch',
      this.activity.branch.id
    ];
  }

  getText(status) {
    switch (status) {
      case 'ERROR':
        return ' has failed';
      case 'CANCELLED':
        return ' was cancelled';
      case 'FINISHED':
        return ' complete';
      case 'CREATED':
        return ' is in progress';
    }
  }
}
